import { Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { WeeklySummaryComment } from "../../../redux/features/weekly-summary-slice";
import { UserResponse } from "../../../redux/features/user-slice";
import { timeAgoWithDate } from "../../../core/utils";
import EmptyDataOverlay from "../../../components/empty-data-overlay";

interface Props {
  user: UserResponse;
  comments: WeeklySummaryComment[];
  setComments: (values: WeeklySummaryComment[]) => void;
}

export default function SummaryCommentsList(props: Props) {
  const { user, comments, setComments } = props;

  return (
    <div className="h-full flex flex-col p-4 space-y-6 rounded-lg border border-divider">
      <div
        className="flex flex-col overflow-y-scroll"
        style={{
          height: "calc(100% - 48px)",
        }}
      >
        {comments.length > 0 ? (
          [...comments]
            .sort((a, b) => {
              const timeA = new Date(a.timestamp).getTime();
              const timeB = new Date(b.timestamp).getTime();
              return timeB - timeA; // Sort in descending order
            })
            .map((comment: WeeklySummaryComment, index: number) => (
              <div
                className={`w-full flex flex-col space-y-2 text-sm py-4 ${
                  index > 0 ? "border-t border-divider border-dashed" : ""
                }`}
              >
                <div className="flex items-center space-x-2">
                  <label className="font-medium">{comment.user.name}</label>
                  <label className="text-xs text-text-title">
                    {timeAgoWithDate(new Date(comment.timestamp))}
                  </label>
                </div>
                <label className="max-w-full bg-background-paper text-text-primary break-words">
                  {comment.message}
                </label>
              </div>
            ))
        ) : (
          <EmptyDataOverlay label="No messages found" exClassName="h-full" />
        )}
      </div>
      <Formik
        initialValues={{ comment: "" }}
        validationSchema={Yup.object().shape({
          comment: Yup.string().required(),
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(false);
          setComments([
            ...comments,
            { user: user, message: values.comment, timestamp: new Date() },
          ]);
          resetForm();
        }}
      >
        {({ values, errors, handleChange, handleSubmit }) => (
          <Form
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
            className="flex items-center space-x-2 bg-background-paper p-2 border border-divider rounded-lg cursor-pointer"
          >
            <Input
              id="comment"
              placeholder="Write a comment..."
              value={values.comment}
              onChange={handleChange}
              exClassName="border-none"
              exWrapClassName="w-full"
            />
            <Button
              label="Send"
              exClassName="flex justify-right"
              disabled={
                Array.isArray(errors) || Object.values(errors).toString() != ""
              }
            />
          </Form>
        )}
      </Formik>
    </div>
  );
}
